import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/titleIcon2.png'


const _withScopeId = n => (_pushScopeId("data-v-374c62fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sbomData-container" }
const _hoisted_2 = { class: "sbomData-part" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" General ")
], -1))
const _hoisted_4 = { class: "content-box" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "软件包名称：", -1))
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  key: 0,
  class: "label"
}
const _hoisted_10 = {
  key: 1,
  class: "label"
}
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "来源信息：", -1))
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "漏洞：", -1))
const _hoisted_17 = { class: "txt" }
const _hoisted_18 = { class: "num" }
const _hoisted_19 = { class: "content" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "License：", -1))
const _hoisted_21 = { class: "sbomData-part" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Source Control ")
], -1))
const _hoisted_23 = { class: "content-box" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Home Page:", -1))
const _hoisted_26 = { class: "content" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Download Location:", -1))
const _hoisted_28 = { class: "content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Supplier:", -1))
const _hoisted_30 = { class: "sbomData-part" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Description ")
], -1))
const _hoisted_32 = { class: "content-box" }
const _hoisted_33 = { class: "sbomData-part" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "part-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" Summary ")
], -1))
const _hoisted_35 = { class: "content-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_licenseTmp = _resolveComponent("licenseTmp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.sbomData.name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.flag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "版本(epoch:version-release)："))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, "版本：")),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.sbomData.version), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.sbomData.sourceInfo), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vluProps, (vul, vulIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (
                _ctx.vulnerabilityData &&
                (_ctx.vulnerabilityData[vul.prop] ||
                  _ctx.vulnerabilityData[vul.prop] === 0)
              )
                ? (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(['vulBtns', 'vul' + vulIndex]),
                    key: vulIndex,
                    style: {"cursor":"default"}
                  }, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(vul.label), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.vulnerabilityData[vul.prop]), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_licenseTmp, { license: _ctx.sbomData }, null, 8, ["license"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", {
            class: _normalizeClass(['name', { link: _ctx.formatPointer(_ctx.sbomData.homepage) }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goPath(_ctx.sbomData.homepage)))
          }, _toDisplayString(_ctx.sbomData.homepage), 3)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", {
            class: _normalizeClass([
              'name',
              { link: _ctx.formatPointer(_ctx.sbomData.downloadLocation) },
            ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goPath(_ctx.sbomData.downloadLocation)))
          }, _toDisplayString(_ctx.sbomData.downloadLocation), 3)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", {
            class: _normalizeClass(['name', { link: _ctx.formatPointer(_ctx.sbomData.supplier) }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goPath(_ctx.sbomData.supplier)))
          }, _toDisplayString(_ctx.sbomData.supplier), 3)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.sbomData.description), 1)
    ]),
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.sbomData.summary), 1)
    ])
  ]))
}